import { fetchServices } from '@/api/service'
const getServiceRefreshment = (context) => {
  fetchServices().then((response) => {
    context.commit(
      'SERVICEREFRESHMENT_UPDATED',
      _.find(response, function (o) {
        return o.service_id == 2
      })
    )
  })
}

export default {
  getServiceRefreshment
}
